import { CSVProfile } from '../../types'
import { DoubleChartComponent } from '../charts/double-chart-component'
import { TRANSFORM_MILLI_TO_DATE } from '../commons/constants'

export class AFCompareSovByImpressions extends DoubleChartComponent {
 static config = {
  selector: 'afCompareSovByImpressions',
  controller: AFCompareSovByImpressions,
  bindings: DoubleChartComponent.config.bindings,
  template: DoubleChartComponent.config.template,
 }

 setProperties() {
  this.buildCSVExportProfile()
 }

 buildCSVExportProfile() {
  // ensure data is reset, otherwise array data will grow
  this.csvExportProfiles = []

  // TODO: the data for this widget need to be formatted in a consistent way to avoid the hack below.
  // *******************************
  let donutData = Object.assign({}, { all: this.namingUtils.returnData(this.vizData.extendedData.donut.data) })
  let donutExport: CSVProfile = {
   //cloning data to avoid mutation
   data: donutData,
   csvOptions: { title: this.properties.title, headers: ['Category', 'Count'] },
   transformationProfiles: [],
  }

  let splineExport: CSVProfile = {
   data: Object.assign({}, this.vizData.extendedData.spline.data),
   csvOptions: { headers: ['Date', 'Count'], showTitle: false },
   transformationProfiles: [{ key: 'key', type: TRANSFORM_MILLI_TO_DATE }],
  }

  this.csvExportProfiles.push(donutExport, splineExport)
 }
}
